export default __webpack_public_path__ + "static/media/facebook.384c7806.svg";